<template>
  <modal id="media-library-modal" title="Media Library" :width="`${width}%`">
    <media-library
      :selected_ids="selected_ids"
      :mediaCatcher="mediaLibraryCatcher"
      :only_extensions="only_extensions"
      :multiple="multiple"
      :types="types"
      :max="max"
      :onClickCancel="onClickCancel" />
  </modal>
</template>

<script>
import Modal from '~/components/containers/Modal';

export default {
  components: {
    Modal
  },
  
  props: {
    mediaCatcher: {
      type: Function,
      default: () => {}
    },
    selected_ids: {
      type: Array,
      default: () => []
    },
    only_extensions: {
      type: Array,
      default: () => []
    },
    types: {
      type: Array,
      default: () => []
    },
    multiple: {
      type: Boolean,
      default: true
    },
    width: {
      type: Number,
      default: 90,
    },
    max: {
      type: [Number, String],
      default: 5,
    },
    onClickCancel: {
      type: Function,
      default: () => {},
    },
  },

  methods: {
    mediaLibraryCatcher(medias) {
      this.mediaCatcher(medias, this.types);
    }
  }
}
</script>
